import { CheckCircle, ErrorOutline } from "@mui/icons-material";

function Row({ label, check, extra }) {
  if (!check) return null;
  return (
    <li className="flex items-start gap-2 text-sm">
      {check.ok ? (
        <CheckCircle fontSize="small" className="text-app-status-completed-text" />
      ) : (
        <ErrorOutline fontSize="small" className="text-app-status-cancelled-text" />
      )}
      <span>
        <strong>{label}</strong>
        {check.ok ? ` ${check.name || ""}${extra ? ` (${extra})` : ""}` : `: ${check.problem}`}
      </span>
    </li>
  );
}

export default function ConnectionTestResult({ result }) {
  if (!result) return null;
  return (
    <div className="space-y-2 rounded border border-app-border bg-app-surface-alt p-3">
      <p className="text-sm font-medium">
        {result.ok
          ? "Everything checks out."
          : "Meta accepted the token but something needs fixing."}
      </p>
      <ul className="space-y-1">
        <Row label="Ad account" check={result.adAccount} extra={result.currency} />
        <Row label="Facebook page" check={result.page} />
        <Row label="Instagram" check={result.instagram} />
      </ul>
      {result.missingPermissions?.length ? (
        <p className="text-sm text-app-status-cancelled-text">
          The token is missing: {result.missingPermissions.join(", ")}.
        </p>
      ) : null}
      {result.missingLeadPermissions?.length ? (
        <p className="text-sm text-app-text-secondary">
          Lead ads and the lead inbox also need: {result.missingLeadPermissions.join(", ")}. Other
          ads work without them.
        </p>
      ) : null}
    </div>
  );
}
